import React from "react";
import cn from "classnames";
import { useTranslation } from "react-i18next";
import { formatCurrency } from "@app/utils";
import { useCalculator } from "../use-calculator";

export const CardCompare = () => {
  const { t } = useTranslation("calculator");
  const { data, value } = useCalculator();

  return (
    <div className="flex items-center justify-between gap-2.5 overflow-x-auto overflow-y-hidden text-extra-small">
      <div
        className={cn(
          { flex: !value, hidden: value },
          "absolute inset-0 z-10 items-center justify-center [backdropFilter:blur(4px)]",
        )}
      />
      <div>
        <div className="mb-2.5 flex flex-auto items-center whitespace-nowrap text-primary-content">
          <div className="mr-1.5 h-2.5 w-2.5 rounded-full bg-green-light" />
          Alpian (CHF)
        </div>
        <div className="flex flex-auto items-center whitespace-nowrap text-primary-content">
          <div className="mr-1.5 h-2.5 w-2.5 rounded-full bg-white" />
          {t("others")} (CHF)
        </div>
      </div>
      {data.map((item) => (
        <div key={`${item.year}`} className="text-center">
          <div className="mb-2.5 text-primary-content">
            {formatCurrency(item.alpianAmt, true)}
          </div>
          <div className="text-neutral-content">
            {formatCurrency(item.otherAmt, true)}
          </div>
        </div>
      ))}
    </div>
  );
};
